import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { SidepanelModalService } from "@app/sidepanel/services/sidepanel-modal.service";
import { BsModalRef } from "ngx-bootstrap";
import { FormBuilder, Validators } from "@angular/forms";
import { CommunicationDispatcherService } from "@app/shared/communication-mapping/services/communication-dispatcher.service";
import { CommunicationHelperService } from "@app/shared/communication-mapping/services/communication-helper.service";
import { AppValidators, CsModalComponent } from "@app/directives";
import { AuthService } from "@app/core";
var CommunicationSegmentComponent = /** @class */ (function () {
    function CommunicationSegmentComponent(fb, modalService, bsSideModalRef, eventDispatcher, helperService, authService) {
        this.fb = fb;
        this.modalService = modalService;
        this.bsSideModalRef = bsSideModalRef;
        this.eventDispatcher = eventDispatcher;
        this.helperService = helperService;
        this.authService = authService;
        this.loading = true;
        this.optionFullFilled = false;
        this.segmentations = [];
        this.possibleSegCategories = []; // seg cat
        this.possibleSeg2Categories = []; // seg cat without seg1 val
        this.segmentationSetupSaving = false;
        this.list = [];
        this.configuredLTCList = [];
        this.cloneAllocationsSelect2Config = {
            placeholder: '',
            multiple: true,
            width: '100%',
            data: []
        };
        this.cloneAllocationsModalIsOpen = false;
        this.secondarySegmentation = false;
        this.segmentationEditAccess = false;
        this.opportunityScreen = false;
    }
    CommunicationSegmentComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.secondarySegmentation = this.authService.permitted(['SetupSecondarySegmentation.readaccess']) === true;
        this.segmentationEditAccess = this.authService.permitted(['SetupSecondarySegmentation.writeaccess']) === true;
        if (this.screenType === 'send_proposal_template' || this.screenType === 'on_way_notification_template' ||
            this.screenType === 'work_address_confirmation_template' || this.screenType === 'customer_confirmation_template') {
            this.opportunityScreen = true;
        }
        this.segmentations = [
            { selected: false, AnySeleted: false, category: '', categoryName: '', listItems: [], process: 'loading', searchText: '', activeItem: 0, listItemsFiltered: [] },
            { selected: false, AnySeleted: false, category: '', categoryName: '', listItems: [], process: 'loading', searchText: '', activeItem: 0, listItemsFiltered: [] } //api
        ];
        this.cloneAllocationsForm = this.fb.group({
            'sourceSegmentLevel': ['', [Validators.required]],
            'targetValues': [[], [AppValidators.nonEmptylistValidator]]
        });
        this.subscription = this.eventDispatcher.triggerEvent$.subscribe({
            next: function (data) {
                if (typeof data != 'object' || !data['actionName']) {
                    return;
                }
                var action = data['actionName'];
                /* Initial load */
                if (action == 'event:loadedData') {
                    var value = data['data'];
                    _this.inputModel = value['inputModel'];
                    _this.possibleSegCategories = value['layoutComponent'].possibleSegCategories;
                    _this.getSegCategoriesList = value['layoutComponent'].getSegCategoriesList;
                    _this.openLabourTab(_this.inputModel);
                    _this.segmentSelection(0, -1);
                    _this.segmentSelection(1, -1);
                    _this.loading = false;
                }
                if (action == 'event:updateFormValue') {
                    var value = data['for'];
                    var _loop_1 = function (i) {
                        var index = _this.segmentations[i - 1].listItems.findIndex(function (el) { return el.id === _this.inputModel['activeSegmentationValue' + i]; });
                        if (index != -1 && value && value != "clone" && value != "update")
                            _this.segmentations[i - 1].listItems[index].selected = !_this.segmentations[i - 1].listItems[index].selected;
                        else {
                            if (index != -1 && value && value == "update")
                                _this.segmentations[i - 1].listItems[index].selected = true;
                            if (index != -1 && data.from == "clearOption") {
                                if (data.inputModel.templates.some(function (obj) { obj.segmentationValue1 == data.inputModel.activeSegmentationValue1 && obj.segmentationValue2 == data.inputModel.activeSegmentationValue2; })) {
                                    _this.segmentations[i - 1].listItems[index].selected = true;
                                }
                                else {
                                    _this.segmentations[i - 1].listItems[index].selected = false;
                                }
                            }
                        }
                    };
                    for (var i = 1; i < 3; i++) {
                        _loop_1(i);
                    }
                    _this.segmentSelection();
                    _this.loading = false;
                }
            }
        });
        this.segmentationSetupForm = this.fb.group({
            'segmentation_1': ['', [Validators.required]],
            'segmentation_2': ['',]
        });
    };
    CommunicationSegmentComponent.prototype.segmentSelection = function (seg, id) {
        var _this = this;
        if (seg === void 0) { seg = null; }
        if (id === void 0) { id = null; }
        if (seg != null) {
            this.segmentations[seg].activeItem = id;
            this.inputModel['activeSegmentationValue' + (seg + 1)] = id;
            if (this.inputModel && this.inputModel.settings.allowSegmentation) {
                if (this.inputModel.templates.find(function (obj) { return (obj['segmentationValue' + (seg + 1)] == -1); })) {
                    this.segmentations[seg].AnySeleted = true;
                }
                else {
                    this.segmentations[seg].AnySeleted = false;
                }
            }
        }
        var filteredInput = this.inputModel['templates'].filter(function (c) { return parseInt(c.segmentationValue1) == _this.segmentations[0].activeItem && parseInt(c.segmentationValue2) == _this.segmentations[1].activeItem; });
        this.optionFullFilled = (filteredInput.length > 0 && this.segmentations[0].category == this.inputModel.segmentationType1 && this.segmentations[1].category == this.inputModel.segmentationType2);
        var type = '';
        if (this.optionFullFilled) {
            type = filteredInput.length > 1 ? (filteredInput[0]['communicationType'] == 'email' ? filteredInput[0]['communicationType'] : filteredInput[1]['communicationType']) : filteredInput[0]['communicationType'];
            var emailTitle = filteredInput.find(function (i) { return i.communicationType == 'email'; });
            var smsTitle = filteredInput.find(function (i) { return i.communicationType == 'sms'; });
            this.inputModel['title'] = [emailTitle ? emailTitle['title'] : '', smsTitle ? smsTitle['title'] : ''];
            this.eventDispatcher.dispatchEvent(CommunicationDispatcherService.CONSTANTS['updateTemplateDetails'], {
                type: type,
                value: filteredInput[0],
                inputModel: this.inputModel,
                multiValue: filteredInput,
                from: 'segmentSelected'
            });
        }
        else {
            this.inputModel['title'] = '';
            this.eventDispatcher.dispatchEvent(CommunicationDispatcherService.CONSTANTS['updateTemplateDetails'], {
                type: type,
                value: { segmentations: this.segmentations },
                inputModel: this.inputModel,
                from: 'segmentSelected'
            });
        }
    };
    CommunicationSegmentComponent.prototype.deleteSegment = function (seg) {
        if (seg == 0) {
            this.segmentations[0].selected = this.segmentations[1].selected;
            this.segmentations[0].category = this.segmentations[1].category;
            this.segmentations[0].categoryName = this.segmentations[1].categoryName;
            this.segmentations[0].listItems = this.segmentations[1].listItems;
            this.segmentations[0].listItemsFiltered = this.segmentations[1].listItemsFiltered;
            this.segmentationSetupForm.value['segmentation_1'] = this.segmentationSetupForm.value['segmentation_2'];
            this.inputModel.segmentationType1 = this.inputModel.segmentationType2;
        }
        this.segmentations[1].selected = false;
        this.segmentations[1].category = null;
        this.segmentationSetupForm.value['segmentation_2'] = '';
        this.inputModel.segmentationType2 = null;
        if (!this.segmentations[0].selected && !this.segmentations[1].selected) {
            this.inputModel.templates = [];
        }
        this.segmentations[0].listItems = this.segmentations[0].listItems.map(function (item) { return tslib_1.__assign({}, item, { selected: false }); });
        this.segmentations[0].listItemsFiltered = this.segmentations[0].listItems;
        this.inputModel.templates = this.inputModel.templates.filter(function (obj) { return (obj['segmentationValue1'] == "-1" && obj['segmentationValue2'] == "-1"); });
        this.segmentSelection(seg, -1);
    };
    CommunicationSegmentComponent.prototype.openSidepanel = function () {
        var _this = this;
        var patchValue = {
            'segmentation_1': '',
            'segmentation_2': ''
        };
        if (this.segmentations.length) {
            patchValue['segmentation_1'] = this.segmentations[0].selected ? this.segmentations[0].category : '';
            this.possibleSeg2Categories = this.possibleSegCategories.filter(function (c) { return c['value'] !== _this.segmentations[0].category; });
            if (this.segmentations.length > 1) {
                patchValue['segmentation_2'] = this.segmentations[1].selected ? this.segmentations[1].category : '';
            }
        }
        this.segmentationSetupForm.patchValue(patchValue);
        this.segmentationSetupForm.updateValueAndValidity();
        this.bsSideModalRef = this.modalService.show(this.addEditSegmentationPanel, {});
        setTimeout(function () {
            if (_this.opportunityScreen && !_this.segmentationEditAccess) {
                $('#secondarySegment').prop('disabled', true);
            }
            else {
                $('#secondarySegment').prop('disabled', false);
            }
        }, 500);
    };
    CommunicationSegmentComponent.prototype.onSidepanelClose = function () {
        if (this.bsSideModalRef.content == null) {
            this.bsSideModalRef.hide();
        }
    };
    CommunicationSegmentComponent.prototype.openLabourTab = function (input) {
        var _this = this;
        if (input === void 0) { input = false; }
        var seg = [input ? input.segmentationType1 : this.segmentationSetupForm.value['segmentation_1'], input ? input.segmentationType2 : this.segmentationSetupForm.value['segmentation_2']];
        if (seg[0] != this.inputModel.segmentationType1 || seg[1] != this.inputModel.segmentationType2) {
            this.inputModel.templates = this.inputModel.templates.filter(function (obj) { return obj.segmentationValue1 == -1 && obj.segmentationValue2 == -1; });
            var emailTitle = this.inputModel.templates.find(function (i) { return i.communicationType == 'email'; });
            var smsTitle = this.inputModel.templates.find(function (i) { return i.communicationType == 'sms'; });
            this.inputModel['title'] = [emailTitle ? emailTitle['title'] : '', smsTitle ? smsTitle['title'] : ''];
            this.optionFullFilled = this.inputModel.templates.length > 0 ? this.optionFullFilled : false;
            this.segmentations[0].activeItem = this.segmentations[1].activeItem = -1;
        }
        for (var i in seg) {
            this.segmentations[i].categoryName = seg[i] ? this.possibleSegCategories.find(function (x) { return x.value == seg[i]; })['value'] : '';
            this.segmentations[i].category = seg[i];
            this.inputModel["segmentationType" + (parseInt(i) + 1)] = this.segmentations[i].category;
        }
        this.segmentations[0].selected = seg[0] ? true : false;
        this.segmentations[1].selected = seg[0] && seg[1] ? true : false;
        // this.inputModel.templates=[];
        this.eventDispatcher.dispatchEvent(CommunicationDispatcherService.CONSTANTS['updateTemplateDetails'], {
            inputModel: this.inputModel
        });
        this.getSegCategoriesList(seg[0], function (val) { return _this.setSegCategoriesList(0, val, input.templates); });
        this.getSegCategoriesList(seg[1], function (val) { return _this.setSegCategoriesList(1, val, input.templates); });
        this.segmentSelection();
        this.onSidepanelClose();
    };
    CommunicationSegmentComponent.prototype.setSegCategoriesList = function (index, val, input) {
        if (input) {
            input.map(function (todo, i) {
                if (todo['segmentationValue' + (index + 1)] != null) {
                    var itemIndex = val.listItems.findIndex(function (item) { return item.id == parseInt(todo['segmentationValue' + (index + 1)]); });
                    if (itemIndex != -1) {
                        val.listItems[itemIndex].selected = true;
                    }
                }
            });
        }
        this.segmentations[index]['listItems'] = this.segmentations[index]['listItemsFiltered'] = val.listItems;
        this.segmentations[index]['process'] = (val.process === '' || val.process === 'loading') ? val.process = 'loading' : val.process = 'loaded';
    };
    CommunicationSegmentComponent.prototype.checkSegmentation = function ($event) {
        this.possibleSeg2Categories = this.possibleSegCategories.filter(function (c) { return c['value'] !== $event.target.value; });
        var seg2Control = this.segmentationSetupForm.controls['segmentation_2'];
        if ($event.target.value == '' || $event.target.value == seg2Control.value) {
            seg2Control.setValue('');
            seg2Control.updateValueAndValidity();
        }
    };
    CommunicationSegmentComponent.prototype.onSegLineItemSearch = function (segIndex) {
        var _this = this;
        this.segmentations[segIndex].listItemsFiltered = this.segmentations[segIndex].listItems
            .filter(function (i) { return (new RegExp(_this.segmentations[segIndex].searchText, 'i')).test(i.text); });
    };
    CommunicationSegmentComponent.prototype.openCloneModal = function (segIndex, value) {
        this.cloneAllocationsForm.patchValue({
            'sourceSegmentLevel': segIndex,
            'targetValues': []
        });
        this.cloneAllocationsSelect2Config['data'] = this.segmentations[segIndex].listItems.filter(function (item) { return item.id !== value; });
        this.cloneAllocationsModalIsOpen = true;
        this.cloneAllocationsModal.open();
    };
    CommunicationSegmentComponent.prototype.onCloneClick = function (segIndex, value) {
        event.stopPropagation();
        this.openCloneModal(segIndex, value);
    };
    CommunicationSegmentComponent.prototype.onCloneTargetSegmentSelect = function (event) {
        this.cloneAllocationsForm.controls['targetValues'].setValue(event);
        this.cloneAllocationsForm.controls['targetValues'].markAsTouched();
        this.cloneAllocationsForm.controls['targetValues'].updateValueAndValidity();
    };
    CommunicationSegmentComponent.prototype.cloneAllocations = function () {
        var _this = this;
        var result = this.inputModel['templates'].filter(function (item) { return (item.segmentationValue1 == _this.segmentations[0].activeItem && item.segmentationValue2 == _this.segmentations[1].activeItem); });
        for (var _i = 0, _a = this.cloneAllocationsForm.value.targetValues; _i < _a.length; _i++) {
            var val = _a[_i];
            var foundIndex = this.segmentations[this.cloneAllocationsForm.value.sourceSegmentLevel].listItemsFiltered.findIndex(function (x) { return x.id == val; });
            this.segmentations[this.cloneAllocationsForm.value.sourceSegmentLevel].listItemsFiltered[foundIndex].selected = true;
            this.segmentations[this.cloneAllocationsForm.value.sourceSegmentLevel].listItems[foundIndex].selected = true;
        }
        this.segmentations[this.cloneAllocationsForm.value.sourceSegmentLevel].listItemsFiltered = this.segmentations[this.cloneAllocationsForm.value.sourceSegmentLevel].listItems;
        this.eventDispatcher.dispatchEvent(CommunicationDispatcherService.CONSTANTS['cloneData'], {
            data: { 'list': result, 'segmentationDetails': this.cloneAllocationsForm.value },
            inputModel: this.inputModel
        });
        this.cloneAllocationsModal.close();
    };
    CommunicationSegmentComponent.prototype.onCloneModalClose = function () {
        this.cloneAllocationsForm.reset();
        this.cloneAllocationsModalIsOpen = false;
    };
    CommunicationSegmentComponent.prototype.convertToTitleCase = function (input, type) {
        if (type === void 0) { type = ''; }
        // Split the string by underscores
        var words = input.split('_');
        var result = '';
        if (type === 'placeholder') {
            // Join the words back together with spaces
            result = words.join(' ').toLowerCase();
        }
        else {
            // Capitalize the first letter of the first word
            words[0] = words[0].charAt(0).toUpperCase() + words[0].slice(1).toLowerCase();
            // Join the words back together with spaces
            result = words.join(' ').toLowerCase();
            // Ensure the first word is properly capitalized
            result = result.charAt(0).toUpperCase() + result.slice(1);
        }
        return result;
    };
    return CommunicationSegmentComponent;
}());
export { CommunicationSegmentComponent };
